export const baseURL = window.baseURL + '/api/'